import ReactDOM from 'react-dom';
import UserGroupSync from "../../elements/UserGroupSync/UserGroupSync.tsx";

const UserGroupSyncPortal = () =>  {

    let targetContainer = document.getElementById('react-user-group-sync-container');

    if (!targetContainer) {
        //if there is nowhere for the portal, do not display
        return null;
    } else {
        return ReactDOM.createPortal(
            <UserGroupSync />,
            targetContainer
        );
    }
}

export default UserGroupSyncPortal;